/**
 * Created For: 药厂信息相关接口
 * Author: chenLiYan.
 * Date: 2018/11/30 0030 16:17.
 */
import request from '@/utils/request'

// 获取属于用户的药品信息
export function asyncGetUserDrug (params) {
  return request({
    url: '/v1/drug_factory/get_user_all_drug',
    params,
    method: 'get'
  })
}
